import { render } from "./SaveButton.vue?vue&type=template&id=8bb863a6&scoped=true"
import script from "./SaveButton.vue?vue&type=script&lang=js"
export * from "./SaveButton.vue?vue&type=script&lang=js"

import "./SaveButton.vue?vue&type=style&index=0&id=8bb863a6&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb863a6"]])

export default __exports__